import http from "@/utils/axios";
import { apiPaths } from "@/dictionaries/api/paths";

export default {
  namespaced: true,
  state: {
    employees: [],
    errors: [],
    pagination: {
      currentPage: 1,
      total: 1,
    },
    search: "",
  },
  getters: {
    getEmployees: (state) => state.employees,
    getErrors: (state) => state.errors,
    getPagination: (state) => state.pagination,
    getSearch: (state) => state.search,
  },
  mutations: {
    setEmployees(state, employees) {
      state.employees = employees.data;
      state.pagination.currentPage = employees.meta.current_page;
      state.pagination.total = employees.meta.last_page;
    },
    setErrors(state, errors) {
      state.errors = errors;
    },
    addError(state, { key, error }) {
      state.errors = {
        ...state.errors,
        [key]: error,
      };
    },
    clearErrors(state) {
      state.errors = [];
    },
    setSearch(state, search) {
      state.search = search;
    },
    setCurrentPage(state, currentPage) {
      state.pagination.currentPage = currentPage;
    },
    clearSearch(state) {
      state.search = "";
    },
    clearEmployees(state) {
      state.employees = [];
      state.pagination.currentPage = 1;
      state.pagination.total = 1;
    },
  },
  actions: {
    async fetchEmployees({ commit, state }, sortBy) {
      const response = await http.get(apiPaths.clinic.employees.exact, {
        params: {
          page: state.pagination.currentPage,
          search: state.search,
          ...sortBy,
        },
      });
      const employees = response.data;
      commit("setEmployees", employees);
    },
  },
};
